function normalizeUidList(values = []) {
  return Array.from(new Set(values
    .map((value) => (typeof value === 'string' ? value.trim() : ''))
    .filter(Boolean)));
}

export function extractSupportAdminIds(data = {}) {
  const ids = [];
  if (Array.isArray(data?.adminIds)) {
    ids.push(...data.adminIds);
  }
  if (Array.isArray(data?.admins)) {
    ids.push(...data.admins);
  }
  if (data?.admins && typeof data.admins === 'object') {
    ids.push(...Object.values(data.admins));
  }
  return normalizeUidList(ids);
}

export function extractRuleCompatibleSupportAdminIds(data = {}) {
  const ids = [];
  if (Array.isArray(data?.adminIds)) {
    ids.push(...data.adminIds);
  }
  if (Array.isArray(data?.admins)) {
    ids.push(...data.admins);
  } else if (data?.admins && typeof data.admins === 'object') {
    Object.entries(data.admins).forEach(([key, value]) => {
      if (value === true || value === key) ids.push(key);
    });
  }
  return normalizeUidList(ids);
}
